import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import Backend from 'i18next-http-backend';

i18n
  // Load translation using http backend
  .use(Backend)
  // Detect user language
  .use(LanguageDetector)
  // Pass the i18n instance to react-i18next
  .use(initReactI18next)
  // Init i18next
  .init({
    // Languages
    supportedLngs: ['ar', 'en'],
    fallbackLng: 'ar',
    debug: false,
    
    // Language detection options
    detection: {
      order: ['localStorage', 'cookie', 'navigator', 'htmlTag'],
      caches: ['localStorage', 'cookie'],
      lookupLocalStorage: 'badeel_language',
      lookupCookie: 'badeel_language'
    },
    
    // Translation loading
    backend: {
      loadPath: '/locales/{{lng}}/{{ns}}.json',
    },
    
    // Default namespace
    defaultNS: 'common',
    ns: ['common'],
    
    interpolation: {
      escapeValue: false // React already escapes values
    },
    
    react: {
      useSuspense: true
    }
  });

// Update HTML attributes when language changes
i18n.on('languageChanged', (lng) => {
  const dir = lng === 'ar' ? 'rtl' : 'ltr';
  document.documentElement.dir = dir;
  document.documentElement.lang = lng;
  
  // Update body classes for Tailwind RTL
  if (lng === 'ar') {
    document.body.classList.add('rtl');
    document.body.classList.remove('ltr');
    // Force re-render for better RTL support
    document.body.style.direction = 'rtl';
  } else {
    document.body.classList.add('ltr');
    document.body.classList.remove('rtl');
    document.body.style.direction = 'ltr';
  }
  
  // Save to localStorage
  localStorage.setItem('badeel_language', lng);
});

// Set initial direction on load
const currentLang = localStorage.getItem('badeel_language') || 'ar';
const initialDir = currentLang === 'ar' ? 'rtl' : 'ltr';
document.documentElement.dir = initialDir;
document.documentElement.lang = currentLang;
if (currentLang === 'ar') {
  document.body.classList.add('rtl');
  document.body.style.direction = 'rtl';
} else {
  document.body.classList.add('ltr');
  document.body.style.direction = 'ltr';
}

export default i18n;
